import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollYearToDate } from "../../components/PayrollYearToDate";

export const PayrollYearToDatePage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        //  { text: "Payroll", navigateTo: "/settings/year-to-date/payroll" },
      ]}
      mainContents={<PayrollYearToDate />}
    />
  );
};
